// ParsleyConfig definition if not already set
// Validation errors messages for Parsley
// Load this after Parsley

Parsley.addMessages('val', {
    defaultMessage: "Este valor pareix ser invàlit.",
    type: {
        email:        "Este valor deu ser un correu vàlit.",
        url:          "Este valor deu ser una URL vàlida.",
        number:       "Este valor deu ser un número vàlit.",
        integer:      "Este valor deu ser un número vàlit.",
        digits:       "Este valor deu ser un dígit vàlit.",
        alphanum:     "Este valor deu ser alfanumèric."
    },
    notblank:       "Este valor no deu estar en blanc.",
    required:       "Este valor és requerit.",
    pattern:        "Este valor és incorrecte.",
    min:            "Este valor no deu ser menor que %s.",
    max:            "Este valor no deu ser major que %s.",
    range:          "Este valor deu estar entre %s i %s.",
    minlength:      "Este valor es massa curt. La llongitut mínima és de %s caràcters.",
    maxlength:      "Este valor es massa llarg. La llongitut màxima es de %s caràcters.",
    length:         "La llongitut de este valor debe estar entre %s y %s caràcters.",
    mincheck:       "Deu seleccionar al menys %s opcions.",
    maxcheck:       "Deu seleccionar %s opcions o menys.",
    check:          "Deu seleccionar entre %s i %s opcions.",
    equalto:        "Este valor deu ser idèntic."
});

Parsley.setLocale('val');
